<template>
    <v-container class="pa-2" fluid grid-list-sm >
        <div v-if="needInit">{{initData()}}</div>
        
        <v-card v-if="$store.getters.getLanguageList">     
            <div v-if="getShowAnswerEvent">{{showAnswer()}}</div>
            <div v-if="getCheckAnswerEvent">{{checkAnswer('user')}}</div>
            <div v-if="needInit">{{initData()}}</div> 
            <div v-if="myContent">
                <div v-html="myContent.content"></div>
                <v-radio-group v-model="selectedIndex" :mandatory="false">
                    <div v-for="(item, index) in myContent.answer_list" :key="index" >
                    <v-radio :label="item.answer" :value="index" :color="styleObject.color" @change="resetEvaluatedData()"></v-radio>
                    <p v-if="index == selectedIndex && feedback != null " v-bind:style="styleObject">{{feedback}}</p>
                    </div>
                </v-radio-group>
            </div>
        </v-card>
    </v-container>
</template>

<script>
import {mapGetters} from 'vuex'

export default {   
    data() {
        return {
                myContent:  {
                    content: 'loading...',
                    help: 'loading...',
                    answer_list : [{
                        answer : 'loading...',
                        feedback: 'loading...'
                    }]
                },
                myGlobals: null,
                feedback: null,
                showMyHelp: false,
                needInit : false,
                styleObject: {
                    color: 'black',
                },
                selectedIndex: null,
                answersBackup: []

        }
    },
    computed: 
        mapGetters([
                    'getShowAnswerEvent',
                    'getCheckAnswerEvent',
                    'getTryAgainEvent'
                    ])
    ,    
    props: { 
        dcontent: Object
    },
    methods: {
        initData() {
            this.needInit = false         
            this.$store.commit('setFeedback', null)   
            this.myContent = (this.dcontent.data.content)
            this.myGlobals = (this.dcontent.data.globals)
            
            // for multilanguage identification of bad answer
            this.answersBackup = []
            for(let i=0; i < this.myContent.answer_list.length; i++) {
                this.answersBackup.push(this.myContent.answer_list[i].answer)
            }
            
            // shuffle
            for(let i=0; i < this.myContent.answer_list.length; i++) {
                const rand = Math.floor(Math.random() * this.myContent.answer_list.length);
                [this.myContent.answer_list[i], this.myContent.answer_list[rand]] = [this.myContent.answer_list[rand], this.myContent.answer_list[i]];
                [this.myGlobals.ratings[i], this.myGlobals.ratings[rand]] = [this.myGlobals.ratings[rand], this.myGlobals.ratings[i]];
            }                        
        },
        checkAnswer(owner) {
            this.$store.commit('setCheckAnswerEvent', false)
            // console.log('idem na to')
            if ( this.selectedIndex == null) {
                // console.log(this.selectedIndex)
                return
            }
            this.$store.commit('setTryAgainEvent',true)

            this.feedback = this.myContent.answer_list[this.selectedIndex].feedback
            if (this.myGlobals.ratings[this.selectedIndex] == 100)  {
                this.styleObject.color = 'green'
                if (this.myContent.answer_list[this.selectedIndex].feedback == '') this.feedback = 'Correct!'
                this.$store.commit('setAnswer',this.describeAnswer(owner,100,this.getIndex(this.myContent.answer_list[this.selectedIndex].answer, this.answersBackup)))
                this.$store.commit('setCheckRatingEvent',true)
                return
            }
          //  this.$store.commit('setTryAgainEvent',true)
            this.styleObject.color = 'red'
            if (this.myContent.answer_list[this.selectedIndex].feedback == '') this.feedback = 'Sorry, bad answer.'
            this.$store.commit('setAnswer',this.describeAnswer(owner,0,this.getIndex(this.myContent.answer_list[this.selectedIndex].answer, this.answersBackup)))
            this.$store.commit('setCheckRatingEvent',true)
        },
        showAnswer() { 
            this.$store.commit('setShowAnswerEvent', false)
            for(var i = 0; i < this.myGlobals.ratings.length; i++) {
                if (this.myGlobals.ratings[i] == 100) {
                    this.selectedIndex = i
                    this.feedback = this.myContent.answer_list[i].feedback
                    this.checkAnswer('system')
                    return
                }
            }            
        },
        getIndex(value, list) {
           for(let i=0; i<list.length; i++) {
               if (value == list[i]) {
                 //  console.log(list[i]) 
                   return i

               }
           }
           return -1
        },
        resetEvaluatedData() {
            this.feedback = null
            this.styleObject.color = 'black'
        },
        describeAnswer(user, score, index) {
            return {
                solver: user,
                type: 3,
                answer: '',
                answer_index: [index], 
                rating: score
            }
        }
    },
    mounted() {
        this.needInit = true
    }
}
</script>

<style>
</style>